import { Navigate, Outlet } from 'react-router-dom';

// eslint-disable-next-line import/no-extraneous-dependencies
import { AppLayout } from 'bs-unified-ui';
import { UnifiedNavbar } from '~/layout/UnifiedNavbar/UnifiedNavbar';
import ListAnnouncement from '~/pages/Announcement/List';
import CreateEditAnnouncement from '~/pages/Announcement/CreateOrEdit';
import Content from '~/pages/Content';

const App = () => (
  <AppLayout renderSideBar={<UnifiedNavbar />}>
    <Outlet />
    <div id='errorMessage' />
    <div id='toast' />
  </AppLayout>
);

export const protectedRoutes = () => {
  const routers = [
    {
      path: '/',
      element: <App />,
      children: [
        {
          path: '/announcement',
          element: <ListAnnouncement />,
        },
        {
          path: '/announcement/create',
          element: <CreateEditAnnouncement />,
        },
        {
          path: '/announcement/edit/:id',
          element: <CreateEditAnnouncement />,
        },
        {
          path: '/content',
          element: <Content />,
        },
        { path: '', element: <Navigate to='/announcement' replace /> },
        { path: '*', element: <Navigate to='/announcement' replace /> },
      ],
    },
  ];

  return routers;
};
